import type { ComponentProps } from 'react';
import { forwardRef } from 'react';

import styles from './dropdown-menu-caret.module.scss';

export const DropdownMenuCaret = forwardRef<
  HTMLSpanElement,
  ComponentProps<'span'>
>((props, ref) => {
  const { className, children, ...rest } = props;
  return (
    <span
      className={[className, styles.dropdownMenuCaret]
        .filter(Boolean)
        .join(' ')}
      ref={ref}
      {...rest}
    >
      {children}
    </span>
  );
});

DropdownMenuCaret.displayName = 'DropdownMenuCaret';
